import { createFeatureSelector, createSelector } from "@ngrx/store";
import { HttpActionState } from "../../../main/pages/users/userslisting/store/users-listing.reducers";
import { conformInvitationFeatureKey } from "./confirm-invitation.config";
import { IConformInvitationState as IConfirmInvitationState, IErrorResponse } from "./confirm-invitation.reducers";


export const state = createFeatureSelector<IConfirmInvitationState>(conformInvitationFeatureKey);

export const isCheckConfirmUrlLoading = createSelector(state, (state => state.checkConfirmationLinkStatus === HttpActionState.Busy));

export const confirmInvitationUrlError = createSelector(state, state => returnErrorStatus(state.checkConfirmationLinkStatus));

export const confirmInvitationUrlCheckState = createSelector(
    state,
    (state) => ({
        loading: state.checkConfirmationLinkStatus === HttpActionState.Busy,
        error: returnErrorStatus(state.checkConfirmationLinkStatus)
    })
);

export const checkConfirmUrl = createSelector(state, state => state.checkConfirmUrl);

export const getOnboardingStatus = createSelector(
    state,
    (state: IConfirmInvitationState) => state.onboardingStatus
);


function returnErrorStatus(status: HttpActionState | IErrorResponse): IErrorResponse | null {
    if (status !== HttpActionState.Init && status !== HttpActionState.Busy && status !== HttpActionState.Done) {
        return status as IErrorResponse;
    }
    return null;
}
